import type { AxiosError } from "axios";

/** An API error's message. A 422 carries FastAPI's list of validation errors
 *  rather than a string; the first message is surfaced instead of the list. */
export function apiErrorMessage(
  err: AxiosError<{ detail?: unknown }>,
  fallback: string,
): string {
  const detail = err.response?.data.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const first: unknown = detail[0];
    if (first && typeof first === "object" && "msg" in first) {
      // Pydantic appends the full error dump after the first line.
      return String(first.msg).split(/\r?\n/)[0];
    }
  }
  return fallback;
}
